import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1450e436"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_2 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_4 = { class: "absolute right-0 top-0 block pr-4 pt-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-lg font-semibold leading-6 text-gray-900 pb-3 pr-6 border-b border-gray-200",
  id: "contexts-modal-title"
}, "Switch your context", -1))
const _hoisted_7 = {
  key: 0,
  class: "px-6 py-14 text-center text-sm sm:px-14"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-6 w-6 text-gray-400",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 font-semibold text-gray-900" }, "No contexts found", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-gray-500" }, "No available contexts found for this search term. Please try again.", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "transform-gpu gap-y-3 flex flex-col py-1",
  id: "options",
  role: "listbox"
}
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "w-10 h-10 rounded-full flex-none bg-gray-500 overflow-hidden relative border border-gray-300 ring-white ring-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold text-2xl text-white origin-center"
}
const _hoisted_17 = { class: "ml-4 flex-auto" }
const _hoisted_18 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_19 = { class: "text-sm text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XMark = _resolveComponent("XMark")!
  const _component_GenproxInput = _resolveComponent("GenproxInput")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_GenproxButton = _resolveComponent("GenproxButton")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        class: "contexts-modal relative z-50",
        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "simplebar relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all cursor-auto sm:my-8 contexts-modal__container" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        class: "bg-white p-6 pb-4 sticky left-0 top-0 w-full z-10"
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                            class: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
                          }, [
                            _hoisted_5,
                            _createVNode(_component_XMark, { class: "h-6 w-6" })
                          ])
                        ]),
                        _hoisted_6,
                        _createVNode(_component_GenproxInput, {
                          icon: _ctx.magnifyingGlass,
                          inputAttrs: { placeholder: 'Search' },
                          class: "mt-4"
                        }, null, 8, ["icon"])
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                        class: "bg-white px-4 sm:px-6"
                      }, [
                        false
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
                          : (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userContexts, (context, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: `${context?.name}-${index}`,
                                  class: _normalizeClass(['group relative flex border rounded-xl px-3 py-5 cursor-pointer hover:border-gray-400 duration-200 focus:outline-none focus:ring-2 focus:ring-black', _ctx.isCurrentContext(context?.id) ? 'border-black' : 'border-gray-200']),
                                  id: `option-${index}`,
                                  role: "option",
                                  tabindex: "-1"
                                }, [
                                  _createElementVNode("div", _hoisted_14, [
                                    (context?.logo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "w-full h-full object-cover",
                                          src: context?.logo ? context?.logo : null,
                                          alt: ""
                                        }, null, 8, _hoisted_15))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$filters.uppercase(context?.name?.slice(0, 1))), 1))
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("p", _hoisted_18, _toDisplayString(context?.name), 1),
                                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$filters.snakeCaseToTitleCase(context?.context)), 1)
                                  ]),
                                  _createVNode(_component_FormKit, {
                                    name: "context",
                                    disabled: true,
                                    value: _ctx.isCurrentContext(context?.id),
                                    options: [1],
                                    label: "",
                                    "outer-class": "$remove:grow",
                                    "decorator-class": "$remove:mr-1.5",
                                    type: "radio",
                                    "decorator-icon": "circle"
                                  }, {
                                    label: _withCtx(() => []),
                                    _: 2
                                  }, 1032, ["value"])
                                ], 10, _hoisted_13))
                              }), 128))
                            ]))
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                        class: "bg-white p-4 sm:flex sm:flex-row-reverse sm:px-6 sticky left-0 bottom-0 w-full"
                      }, [
                        _createVNode(_component_GenproxButton, {
                          size: "big",
                          class: "w-full",
                          iconPosition: "left",
                          variant: "black",
                          icon: _ctx.userPlus
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Add new entity")
                          ], undefined, true),
                          _: 1
                        }, 8, ["icon"])
                      ])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }, 8, ["show"]))
}